import { createDeepEqualSelector } from './';

export const recommendSelector = (state: any) => state.recommend;

export const recommendDataSelector = createDeepEqualSelector(
  recommendSelector,
  (recommend) => recommend.data,
);
